// components
import FilterForm from "../components/Dashboard/Filters/FilterForm";
import { Action, CustomTagType, ErrorCodes, OperationType, Position, WindowType } from "puzzle";
import SavedFiltersDialog from "../components/SubmissionsList/SearchBar/SavedFiltersDialog";

export const openFilterDialog: Action = [{
  data: {
    labelText: 'filterForm.selectedFilesInfo',
    submissionCount: 0
  },
  type: OperationType.data
}, {
  children: [{
    render: FilterForm
  }],
  className: 'lg abstract-filter-form',
  items: [{
    btnName: 'filterForm.selectedFilesLabel',
    operations: [],
    btnConfig: {
      customTagType: CustomTagType.counter,
      args: ['labelText', 'submissionCount'],
      pos: Position.start
    }
  }, {
    operations: [{
      name: 'exitFilterDialogWarning',
      type: OperationType.action
    }],
    btnName: 'common.close',
    close: false,
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      name: 'exitFilterDialogWarning',
      type: OperationType.action
    }],
    btnName: 'ESCAPE',
    close: false,
  }, {
    operations: [{
      moduleName: 'CustomFieldsFilter',
      name: 'getCustomFiltersData',
      type: OperationType.addOperationData
    }, {
      moduleName: 'FilterForm',
      name: 'getData',
      args: ['getCustomFiltersData'],
      type: OperationType.addOperationData,
      mappingName: 'filterData'
    }, {
      moduleName: 'FilterForm',
      name: 'validateForm',
      mappingName: 'isFilterFormValid',
      type: OperationType.addOperationData
    }, {
      condition: '{isFilterFormValid}',
      conditionOperations: [{
        name: 'createNewFilter',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }],
    btnName: 'createFilter.save',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    close: false
  }],
  title: 'createFilter.title',
  type: OperationType.dialog
}, {
  name: 'getSearchBarData',
  type: OperationType.action
}, {
  data: {
    mainGridFilter: {},
    createFilterForm: true,
    fireMainGridFilter: false
  },
  type: OperationType.data
}, {
  name: 'getSubmissionCount',
  type: OperationType.action
}];

export const updateFilterFormDialogFooter: Action = [{
  data: {
    labelText: 'filterForm.selectedFilesInfo',
  },
  buttons: [],
  customTags: [{
    name: 'filterForm.selectedFilesLabel',
    args: ['labelText', 'submissionCount'],
  }],
  type: OperationType.updateDialog,
}];
export const saveFilterAfterColorChange: Action = [{
  data: {
    template: {
      method: 'put',
      bind: {
        url: '"/filters/edit/" + {filterId}',
        params: '{filterData}'
      }
    },
  },
  mappingName: 'successEditFilterData',
  type: OperationType.request
}, {
  name: 'getFavoriteFilters',
  type: OperationType.action
}];

export const openSavedFiltersDialog: Action = [{
  children: [{
    render: SavedFiltersDialog,
    propArgs: ['allFilters']
  }],
  className: 'md saved-filters',
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnName: 'savedFilter.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  title: 'savedFilter.title',
  type: OperationType.dialog
}];

export const openEditFilterDialog: Action = [{
  data: {
    labelText: 'filterForm.selectedFilesInfo',
    submissionCount: 0
  },
  type: OperationType.data
}, {
  persistent: ['filterData'],
  type: OperationType.addPersistentData
}, {
  children: [{
    render: FilterForm,
    propArgs: ['dashboardFilter']
  }],
  className: 'lg abstract-filter-form',
  items: [{
    btnName: 'filterForm.selectedFilesLabel',
    operations: [],
    btnConfig: {
      customTagType: CustomTagType.counter,
      args: ['labelText', 'submissionCount'],
      pos: Position.start
    }
  }, {
    operations: [{
      name: 'exitFilterDialogWarning',
      type: OperationType.action
    }],
    btnName: 'common.close',
    close: false,
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      name: 'exitFilterDialogWarning',
      type: OperationType.action
    }],
    btnName: 'ESCAPE',
    close: false,
  }, {
    operations: [{
      moduleName: 'CustomFieldsFilter',
      name: 'getCustomFiltersData',
      type: OperationType.addOperationData
    }, {
      moduleName: 'FilterForm',
      args: ['getCustomFiltersData'],
      name: 'saveEditedData',
      type: OperationType.addOperationData
    }, {
      condition: '{saveEditedData.dataChange}',
      conditionOperations: [{
        moduleName: 'FilterForm',
        name: 'validateForm',
        mappingName: 'isFilterFormValid',
        type: OperationType.addOperationData
      }, {
        condition: '{isFilterFormValid}',
        conditionOperations: [{
          name: 'editFilterSave',
          type: OperationType.action
        }, {
          condition: '{successEditFilterData.success}',
          conditionOperations: [{
            condition: '{route() === "view/submissionList"}',
            conditionOperations: [{
              name: 'getAllFilters',
              type: OperationType.action
            }],
            type: OperationType.conditional
          }, {
            windowType: WindowType.dialog,
            type: OperationType.closeWindow
          }],
          type: OperationType.conditional
        }],
        type: OperationType.conditional
      }],
      elseOperations: [{
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }],
      type: OperationType.conditional
    }],
    btnName: 'editFilter.save',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    close: false
  }, {
    operations: [{
      name: 'searchFromFilter',
      type: OperationType.action
    }],
    btnName: 'editFilter.search',
    btnConfig: {
      template: {
        bind: {
          hidden: '{dashboardFilter}'
        }
      },
      themeColor: 'primary',
      pos: Position.end
    },
  }],
  title: 'editFilter.title',
  type: OperationType.dialog
}, {
  data: {
    template: {
      bind: {
        predefinedValues: '{initializeUserData.searchBar}'
      }
    }
  },
  moduleName: 'FilterForm',
  name: 'loadEditFilterData',
  args: ['predefinedValues', 'filterData']
}, {
  moduleName: 'CustomFieldsFilter',
  waitForModule: true,
  name: 'loadFiltersData',
  args: ['filterData']
}, {
  persistent: ['filterData'],
  type: OperationType.removePersistentData
}];

export const editFilterSave: Action = [{
  data: {
    template: {
      method: 'put',
      bind: {
        url: '"/filters/edit/" + {saveEditedData.filterId}',
        params: '{saveEditedData.filterData}'
      }
    },
  },
  mappingName: 'successEditFilterData',
  type: OperationType.request
}, {
  name: 'getFavoriteFilters',
  type: OperationType.action
}];

export const searchFromFilter: Action = [{
  name: 'checkboxSelectionClear',
  type: OperationType.action
}, {
  moduleName: 'CustomFieldsFilter',
  name: 'getCustomFiltersData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      stringifyFormat: false
    }
  },
  moduleName: 'FilterForm',
  name: 'getData',
  args: ['getCustomFiltersData', 'stringifyFormat'],
  mappingName: 'mainGridFilter',
  type: OperationType.addOperationData
}, {
  moduleName: 'SearchBar',
  name: 'addFilterToState',
  args: ['mainGridFilter'],
  waitForModule: true,
  type: OperationType.addOperationData
}, {
  name: 'filterMainGrid',
  type: OperationType.action
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}];

export const exitFilterDialogWarning: Action = [{
  moduleName: 'FilterForm',
  name: 'getFilterChangedValue',
  mappingName: 'filterChanged',
  type: OperationType.addOperationData
}, {
  condition: '{filterChanged}',
  conditionOperations: [{
    name: 'exitFilterDialog.name',
    title: 'exitFilterDialog.title',
    text: 'exitFilterDialog.text',
    className: 'sm',
    items: [{
      btnName: 'common.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      },
      operations: []
    }, {
      btnName: 'common.exit',
      btnConfig: {
        pos: Position.end,
        themeColor: 'error'
      },
      operations: [{
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }],
    }],
    type: OperationType.warning
  }],
  elseOperations: [{
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}];

export const openCloneFilterDialog: Action = [{
  persistent: ['filterData'],
  type: OperationType.addPersistentData
}, {
  data: {
    labelText: 'filterForm.selectedFilesInfo',
    submissionCount: 0
  },
  type: OperationType.data
}, {
  className: 'lg abstract-filter-form',
  children: [{
    render: FilterForm,
    propArgs: ['dashboardFilter']
  }],
  items: [{
    btnName: 'common.close',
    close: false,
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      name: 'exitFilterDialogWarning',
      type: OperationType.action
    }],
  }, {
    operations: [{
      name: 'exitFilterDialogWarning',
      type: OperationType.action
    }],
    btnName: 'ESCAPE',
    close: false,
  }, {
    btnName: 'filterForm.selectedFilesLabel',
    operations: [],
    btnConfig: {
      customTagType: CustomTagType.counter,
      args: ['labelText', 'submissionCount'],
      pos: Position.start
    }
  }, {
    operations: [{
      moduleName: 'CustomFieldsFilter',
      name: 'getCustomFiltersData',
      type: OperationType.addOperationData
    }, {
      moduleName: 'FilterForm',
      name: 'getData',
      args: ['getCustomFiltersData'],
      mappingName: 'filterData',
      type: OperationType.addOperationData
    }, {
      moduleName: 'FilterForm',
      name: 'validateForm',
      mappingName: 'isFilterFormValid',
      type: OperationType.addOperationData
    }, {
      condition: '{isFilterFormValid}',
      conditionOperations: [{
        name: 'createNewFilter',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }],
    btnName: 'cloneFilter.save',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    close: false
  }, {
    operations: [{
      name: 'searchFromFilter',
      type: OperationType.action
    }, {
      data: {
        template: {
          withRefresh: false
        }
      },
      moduleName: 'MainGrid',
      name: 'clearFilter',
      args: ['withRefresh']
    }],
    btnName: 'editFilter.search',
    btnConfig: {
      template: {
        bind: {
          hidden: '{dashboardFilter}'
        }
      },
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  placeholders: {
    template: {
      bind: {
        filterName: "{createFilterTitle}"
      }
    }
  },
  title: 'cloneFilter.filterName',
  type: OperationType.dialog
}, {
  data: {
    template: {
      bind: {
        predefinedValues: '{initializeUserData.searchBar}'
      }
    }
  },
  moduleName: 'FilterForm',
  name: 'loadEditFilterData',
  args: ['predefinedValues', 'filterData']
}, {
  moduleName: 'CustomFieldsFilter',
  waitForModule: true,
  name: 'loadFiltersData',
  args: ['filterData']
}, {
  persistent: ['filterData'],
  type: OperationType.removePersistentData
}];

export const getSearchBarData: Action = [{
  data: {
    template: {
      bind: {
        data: '{initializeUserData.searchBar}'
      }
    }
  },
  waitForModule: true,
  moduleName: 'FilterForm',
  name: 'loadFilterData',
  args: ['data']
}];

export const getAdvancedSearchBarData: Action = [{
  data: {
    template: {
      bind: {
        data: '{initializeUserData.searchBar}'
      }
    }
  },
  waitForModule: true,
  moduleName: 'AdvancedSearchDialog',
  name: 'loadFilterData',
  args: ['data']
}];

export const deleteFilter: Action = [{
  persistent: ['filterIndex', 'updateSavedFilterDialog'],
  type: OperationType.addPersistentData
}, {
  className: 'sm confirm-light',
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }, {
      persistent: ['filterIndex', 'updateSavedFilterDialog'],
      type: OperationType.removePersistentData
    }],
    btnName: 'deleteFilter.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'App',
      type: OperationType.maskModule
    }, {
      data: {
        template: {
          method: 'delete',
          bind: {
            url: '"/filters/delete/" + {filterIndex}',
          }
        }
      },
      type: OperationType.request
    }, {
      moduleName: 'App',
      localeProperty: 'deleteFilterConfirmationMsg',
      type: OperationType.maskModule
    }, {
      condition: '{route()}',
      "view/submissionList": [{
        name: 'getAllFilters',
        type: OperationType.action
      }],
      "view/dashboard": [{
        name: 'getFavoriteFilters',
        type: OperationType.action
      }],
      type: OperationType.switch
    }, {
      moduleName: 'MainGrid',
      name: 'setDynamicSize'
    }, {
      persistent: ['filterIndex', 'updateSavedFilterDialog'],
      type: OperationType.removePersistentData
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }],
    btnName: 'deleteFilter.yes',
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    }
  }],
  text: 'deleteFilter.text',
  title: 'deleteFilter.title',
  type: OperationType.warning
}];

export const getFavoriteFilters: Action = [{
  data: {
    url: `/filters/favorite`,
    method: 'get'
  },
  mappingName: 'filterData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        filters: '{filterData.filters}'
      }
    }
  },
  moduleName: 'Filters',
  name: 'loadFavoritedFilters',
  args: ['filters'],
  type: OperationType.addOperationData
}];

export const getAllFilters: Action = [{
  data: {
    url: `/filters`,
    method: 'get'
  },
  mappingName: 'filterData',
  type: OperationType.request
}, {
  condition: '_.get({filterData}, "filters")',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          filters: '{filterData.filters}'
        }
      }
    },
    moduleName: 'SearchBar',
    name: 'addAllFilters',
    args: ['filters'],
    type: OperationType.addOperationData
  }, {
    condition: '{updateSavedFilterDialog}',
    conditionOperations: [{
      moduleName: 'SavedFiltersDialog',
      name: 'updateFilterData',
      args: ['filters'],
      type: OperationType.addOperationData
    }],
    type: OperationType.conditional
  }, {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }],
  type: OperationType.conditional
}];

export const createNewFilter: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  persistent: ['filterData'],
  type: OperationType.addPersistentData
}, {
  data: {
    url: `/filters/save`,
    template: {
      bind: {
        params: '{filterData}'
      }
    },
  },
  mappingName: 'saveFilterResponse',
  type: OperationType.request
}, {
  condition: '{saveFilterResponse.success} && {route() !== "view/submissionList"}',
  conditionOperations: [{
    name: 'getFavoriteFilters',
    type: OperationType.action
  }, {
    moduleName: 'MainGrid',
    name: 'setDynamicSize'
  }, {
    persistent: ['filterData'],
    type: OperationType.removePersistentData
  }, {
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  elseOperations: [{
    name: 'getAllFilters',
    type: OperationType.action
  }, {
    persistent: ['filterData'],
    type: OperationType.removePersistentData
  }, {
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const updateFavoriteStatus: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  persistent: ['isFavoriteData'],
  type: OperationType.addPersistentData
}, {
  data: {
    url: `/filters/updateFavoriteStatus`,
    method: 'put',
    template: {
      bind: {
        params: '{isFavoriteData}'
      }
    },
  },
  type: OperationType.request
}, {
  moduleName: 'App',
  localeProperty: 'filterStatusUpdated',
  type: OperationType.maskModule
}, {
  name: 'getAllFilters',
  type: OperationType.action
}];

export const saveEditedFilter: Action = [{
  moduleName: 'CustomFieldsFilter',
  name: 'getCustomFiltersData',
  type: OperationType.addOperationData
}, {
  moduleName: 'FilterForm',
  name: 'getData',
  args: ['getCustomFiltersData'],
  type: OperationType.addOperationData,
  mappingName: 'data'
}, {
  moduleName: 'SearchBar',
  name: 'updateDataForPost',
  args: ['data'],
  type: OperationType.addOperationData,
  mappingName: 'saveEditedData'
}, {
  name: 'editFilterSave',
  type: OperationType.action
}, {
  data: {
    closeForm: true
  },
  moduleName: 'SearchBar',
  name: 'clearSearchBar',
  args: ['closeForm']
}, {
  name: 'getAllFilters',
  type: OperationType.action
}, {
  persistent: ['filterData'],
  type: OperationType.removePersistentData
}];

export const openMainSearchForm: Action = [{
  name: 'getSubmissionCount',
  type: OperationType.action
}];

export const getSubmissionCount: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      bind: {
        userName: `_.get({initializeUserData},"userProfile.userInfo.userName")`,
      }
    },
  },
  type: OperationType.data
}, {
  condition: '!{fireMainGridFilter}',
  conditionOperations: [{
    waitForModule: true,
    moduleName: 'CustomFieldsFilter',
    name: 'appendCustomAttributesData',
    args: ['mainGridFilter'],
    mappingName: 'mainGridFilter',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  moduleName: 'MainGrid',
  name: 'updateDataWithFilterParams',
  args: ['pageSize', 'pageNumber', 'mainGridFilter', 'userName', 'createFilterForm'],
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  data: {
    url: '/filters/submissionsCount',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  mappingName: 'submissionCountResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        submissionCount: '{submissionCountResponse.submissionCount}'
      }
    }
  },
  type: OperationType.data
}, {
  condition: '{fireMainGridFilter}',
  conditionOperations: [{
    name: 'filterMainGrid',
    type: OperationType.action
  }, {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }],
  elseOperations: [{
    moduleName: 'App',
    type: OperationType.unmaskModule
  }, {
    name: 'updateFilterFormDialogFooter',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const saveFavoriteFiltersSort: Action = [{
  data: {
    url: '/filters/sortFilters',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  type: OperationType.request
}];

export const getRemoteTagFieldValues: Action = [{
  data: {
    url: '/remoteCombo',
    template: {
      bind: {
        params: '{params}'
      }
    },
  },
  mappingName: 'remoteTagData',
  type: OperationType.request
}, {
  args: ['remoteTagData'],
  moduleName: 'RemoteTagField',
  name: 'setGridData'
}];


export const pingForFilterSubmissionCount: Action = [{
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        url: '{countUrl}',
        params: '{countParams}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  actionType: {
    dispatcherId: 'filterCountDispatcher'
  },
  name: 'preparePingFilterCount',
  type: OperationType.action
}];

export const successPingForSubmissionCount: Action = [{
  evaluate: true,
  moduleName: '{filterModuleName}',
  name: 'pingForFavoritesFilterCount',
  args: ['responseData']
}, {
  persistent: ['filterModuleName'],
  type: OperationType.removePersistentData
}];

export const preparePingFilterCount: Action = [{
  data: {
    template: {
      method: 'post'
    }
  },
  type: OperationType.data
}, {
  persistent: ['filterModuleName', 'countUrl', 'method'],
  type: OperationType.addPersistentData
}, {
  name: 'pingingRequestForFilterCount',
  type: OperationType.action
}]

export const pingingRequestForFilterCount: Action = [{
  condition: '!_.get({responseData}, "response.data.errors")}',
  conditionOperations: [{
    condition: '{responseData} && {responseData.processingFinished}',
    conditionOperations: [{
      name: 'successPingForSubmissionCount',
      type: OperationType.action
    }],
    elseOperations: [{
      actionType: {
        delay: 200
      },
      data: {
        template: {
          processId: {
            bind: {
              processId: '{responseData.processId}'
            }
          }
        }
      },
      name: 'continueWithPingingRequestForFilterCount',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    name: 'stopPingingRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}]

export const stopPingingRequestForFilterCount: Action = [{
  data: {
    dispatcherName: 'filterCountDispatcher'
  },
  moduleName: 'ActionExecutor',
  name: 'getAvailableDispatcher',
  args: ['dispatcherName'],
  mappingName: 'dispatcherExists',
  type: OperationType.addOperationData
}, {
  condition: '{dispatcherExists}',
  type: OperationType.conditional,
  conditionOperations: [{
    dispatcherIds: ['filterCountDispatcher'],
    type: OperationType.stopAll
  }, {
    dispatcherIds: ['filterCountDispatcher'],
    type: OperationType.unlink
  }]
}]

export const continueWithPingingRequestForFilterCount: Action = [{
  condition: '{countUrl}',
  conditionOperations: [{
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    data: {
      template: {
        headers: {
          bind: {
            'X-Process-Uuid': '{processId.processId}'
          }
        },
        bind: {
          method: '{method}',
          url: '{countUrl}'
        }
      }
    },
    mappingName: 'responseData',
    type: OperationType.request
  }, {
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    name: 'pingingRequestForFilterCount',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'stopPingingRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];